"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2098],{

/***/ 20518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_icons_material_ArrowBackIosNewRounded__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76083);
/* harmony import */ var _mui_icons_material_ArrowForwardIosRounded__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47111);
/* harmony import */ var custom_hooks_use_width_hook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44231);
/* harmony import */ var _slick_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84256);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11496);


var _templateObject;










function CustomCarrusel(props) {
  var _props$colorArrow, _props$colorArrow2, _props$children, _props$numberOfPlaceh;

  var width = (0,custom_hooks_use_width_hook__WEBPACK_IMPORTED_MODULE_2__/* .useWidth */ .z)();
  var rows = {
    xs: 1,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4
  };
  var arrowsLeft =
  /*#__PURE__*/

  /*#__PURE__*/
  (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("color:", (_props$colorArrow = props.colorArrow) !== null && _props$colorArrow !== void 0 ? _props$colorArrow : "var(--color-brand-blue-main)", "!important;font-size:clamp(1.5rem, 2.5vw, 2.6rem);padding:2px;position:absolute;z-index:500;left:", width === "xs" || width === "sm" ? "-25px" : "-50px", "!important;top:50%;transform:translateY(-50%);@media (max-width: 600px){left:-15px!important;font-size:1.8rem;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0);
  var arrowsRight =
  /*#__PURE__*/

  /*#__PURE__*/
  (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("color:", (_props$colorArrow2 = props.colorArrow) !== null && _props$colorArrow2 !== void 0 ? _props$colorArrow2 : "var(--color-brand-blue-main)", "!important;font-size:clamp(1.5rem, 2.5vw, 2.6rem);padding:2px;position:absolute;z-index:500;right:", width === "xs" || width === "sm" ? "-25px" : "-50px", "!important;top:50%;transform:translateY(-50%);@media (max-width: 600px){right:-15px!important;font-size:1.8rem;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0);
  var settings = {
    dots: false,
    infinite: ((_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.length) > rows[width],
    speed: 500,
    slidesToShow: rows[width],
    slidesToScroll: 1,
    centerMode: false,
    nextArrow: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_icons_material_ArrowForwardIosRounded__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      css: arrowsRight
    }),
    prevArrow: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_icons_material_ArrowBackIosNewRounded__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      css: arrowsLeft
    }),
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false
      }
    }, {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false
      }
    }]
  };
  var fakeElements = Array.from({
    length: (_props$numberOfPlaceh = props.numberOfPlaceholderItems) !== null && _props$numberOfPlaceh !== void 0 ? _props$numberOfPlaceh : 5
  }, function (v, i) {
    return i;
  });
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(CarruselContainer, {
    container: true,
    justifyContent: "center"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
    item: true,
    xs: 11,
    sm: 11,
    md: 11,
    lg: 10,
    xl: 10,
    my: "auto"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_slick_slider__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, settings, !(props !== null && props !== void 0 && props.children) && props.enablePlaceholder && fakeElements.map(function (e, i) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(props.placeholderItem, {
      key: i
    });
  }), (props === null || props === void 0 ? void 0 : props.children) && props.children)));
}

/* harmony default export */ __webpack_exports__["Z"] = (CustomCarrusel);
var CarruselContainer = (0,_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_templateObject || (_templateObject = (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  position: relative;\n  margin: 5px 0px;\n  \n  & .slick-slider {\n  \n    position: relative;\n  }\n  \n  & .slick-arrow {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 10;\n    \n    &:before {\n      display: none;\n    }\n  }\n  \n  & .slick-prev {\n    left: -40px;\n    \n    @media (max-width: 900px) {\n      left: -25px;\n    }\n    \n    @media (max-width: 600px) {\n      left: -10px;\n    }\n  }\n  \n  & .slick-next {\n    right: -40px;\n    \n    @media (max-width: 900px) {\n      right: -25px;\n    }\n    \n    @media (max-width: 600px) {\n      right: -10px;\n    }\n  }\n  \n  & .slick-list {\n    overflow: hidden;\n  }\n  \n  & .slick-track {\n    display: flex;\n    align-items: stretch;\n  }\n  \n  & .slick-slide {\n    > div {\n      height: 100%;\n    }\n  }\n"])));

/***/ }),

/***/ 25242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var custom_hooks_useGetPersintParamas_hook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53541);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1283);
/* harmony import */ var custom_hooks_useWindowsSize_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51860);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11496);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69661);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);






var CollectionCard = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function (_ref) {
  var theme = _ref.theme;
  return {
    width: "100%",
    maxWidth: "223px",
    position: "relative",
    display: "block",
    margin: "0 auto",
    paddingTop: "25px",
    "@media screen and (max-width: 400px)": {
      padding: "0 10px"
    }
  };
});
var CardLink = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)("a")({
  textDecoration: "none",
  "&:hover, &:active, &:visited": {
    textDecoration: "none"
  }
});
var CardLabel = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)("span")({
  position: "relative",
  left: "10px",
  backgroundColor: "white",
  color: "var(--color-text-black)",
  padding: "5px 10px",
  borderRadius: "10px 10px 0 0",
  letterSpacing: "1px",
  fontSize: ".9rem",
  fontWeight: 400,
  "@media screen and (max-width: 400px)": {
    bottom: "100%"
  }
});
var Thumbnail = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
  width: "100%",
  borderRadius: "15px",
  overflow: "hidden",
  height: "150px",
  position: "relative",
  zIndex: 10,
  backgroundColor: "#192c4f",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
});
var ThumbnailImage = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)("img")({
  width: "100%",
  objectFit: "contain",
  objectPosition: "center"
});
var CardDescription = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)("span")({
  textAlign: "center",
  display: "inline-block",
  width: "100%",
  margin: "20px 0",
  fontSize: "1rem",
  fontWeight: 500,
  color: "var(--color-text-white)",
  city: {
    textTransform: "lowercase",
    "&:first-letter": {
      textTransform: "uppercase"
    }
  }
});
var CardDescriptionLight = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)("span")({
  color: "#fff",
  fontWeight: 400 // textTransform: "lowercase",
  // "&:first-letter": {
  //   textTransform: "uppercase !important",
  // },

});

function PropertyCollectionCard(props) {
  var _props$main_picture$b, _props$main_picture;

  var ref = (0,custom_hooks_useGetPersintParamas_hook__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
  var size = (0,custom_hooks_useWindowsSize_hook__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  var width = size === null || size === void 0 ? void 0 : size.width;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CollectionCard, {
    className: props.className
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CardLink, {
    href: shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_2__/* .CPagesPath.es.collection_property_detail */ .K.es.collection_property_detail(props) + ref,
    className: "collection__card_link",
    target: width > 991 ? "_blank" : "",
    rel: "nofollow noopener noreferrer"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CardLabel, null, "COLLECTION"), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(AvatarStyled, {
    variant: "square",
    src: (_props$main_picture$b = props === null || props === void 0 ? void 0 : (_props$main_picture = props.main_picture) === null || _props$main_picture === void 0 ? void 0 : _props$main_picture.big) !== null && _props$main_picture$b !== void 0 ? _props$main_picture$b : "/icons/remax-balloon.png",
    alt: "Collection Image-".concat(props.id, "-").concat(props.sector, "-").concat(props.realstate_type)
  }, props.id), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CardDescription, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("span", {
    className: "city"
  }, props.realstate_type, " "), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CardDescriptionLight, null, capitalizarFrase(props.sector)))));
}

/* harmony default export */ __webpack_exports__["Z"] = (PropertyCollectionCard);
var AvatarStyled = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
  width: "100%",
  height: "150px",
  borderRadius: "14px",
  overflow: "hidden",
  backgroundColor: "#192c4f"
});

function capitalizarFrase(frase) {
  if (typeof frase != "string") {
    return "";
  }

  var excepciones = ["la", "el", "los", "las", "de", "del", "en", "y", "a", "o", "con", "por", "para", "sin", "sobre", "al", "un", "una", "unos", "unas"];
  return frase.toLowerCase().split(" ").map(function (palabra, index) {
    if (index === 0 || !excepciones.includes(palabra)) {
      return palabra.charAt(0).toUpperCase() + palabra.slice(1);
    }

    return palabra;
  }).join(" ");
}

/***/ }),

/***/ 84256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);

 // Import css files





function SlickSlider(props) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_slick__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, props);
}

/* harmony default export */ __webpack_exports__["Z"] = (SlickSlider);

/***/ }),

/***/ 2098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36864);
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50029);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48228);
/* harmony import */ var api_realestate_request__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13897);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _custom_carrusel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20518);
/* harmony import */ var _messages_result__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52659);
/* harmony import */ var _property_collection_card__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25242);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(88078);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70917);






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










function SliderCollectionProperty(props) {
  var _data$data;

  var arrowColor = props.arrowColor,
      _props$filter = props.filter,
      filter = _props$filter === void 0 ? {} : _props$filter;

  var fetchProjectSlider = /*#__PURE__*/function () {
    var _ref = (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(e) {
      var response;
      return _usr_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,api_realestate_request__WEBPACK_IMPORTED_MODULE_3__/* .getRealestate */ ._G)(_objectSpread({
                page: 1,
                collection: true,
                exclusives: false
              }, filter));

            case 2:
              response = _context.sent;
              return _context.abrupt("return", response);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchProjectSlider(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var _useMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__/* .useMutation */ .D)(["project-slider-collection"], fetchProjectSlider),
      data = _useMutation.data,
      isLoading = _useMutation.isLoading,
      isError = _useMutation.isError,
      mutate = _useMutation.mutate;

  react__WEBPACK_IMPORTED_MODULE_4__.useEffect(function () {
    mutate({});
  }, []);

  if (data && (data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.length) == 0 && !isLoading) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("section", null, props === null || props === void 0 ? void 0 : props.withoutResultsComponent);
  }

  if (isLoading) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_messages_result__WEBPACK_IMPORTED_MODULE_6__/* .MessageResults */ .s, {
      message: "Cargando..."
    });
  }

  if (isError) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_messages_result__WEBPACK_IMPORTED_MODULE_6__/* .MessageResults */ .s, {
      message: "Ha ocurrido un error"
    });
  }

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("section", {
    className: "container"
  }, props.title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(Title, null, props.title, " ", (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(TitleSpan, null, props.subTitle)), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(Wrapper, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_custom_carrusel__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    colorArrow: arrowColor !== null && arrowColor !== void 0 ? arrowColor : "#fff",
    placeholderItem: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(PropertyCollectionCardSkeleton, null),
    enablePlaceholder: true,
    numberOfPlaceholderItems: 10,
    forcePlaceHolder: false
  }, data === null || data === void 0 ? void 0 : data.data.map(function (item, i) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_property_collection_card__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
      key: i
    }, item));
  }))), props.children);
}

/* harmony default export */ __webpack_exports__["Z"] = (SliderCollectionProperty);

var Wrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e162txa92"
} : 0)( true ? {
  name: "87d5hs",
  styles: "display:flex;justify-content:center;padding:10px 5px"
} : 0);

var Title = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h2",  true ? {
  target: "e162txa91"
} : 0)( true ? {
  name: "dfew02",
  styles: "width:100%;text-align:center;text-transform:uppercase;font-size:1.9rem;margin-bottom:30px;color:var(--color-brand-blue-main);line-height:40px"
} : 0);

var TitleSpan = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e162txa90"
} : 0)( true ? {
  name: "1a0w822",
  styles: "font-weight:300"
} : 0);

var PropertyCollectionCardSkeleton = function PropertyCollectionCardSkeleton() {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
    container: true,
    flexDirection: "column",
    item: true,
    sx: {
      maxWidth: "250px",
      padding: "0 5px"
    }
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
    variant: "rounded",
    sx: {
      width: "50%",
      marginLeft: 1.5,
      borderRadius: "5px 5px 0px 0px",
      background: "#ffffff36"
    },
    height: 20
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
    variant: "rounded",
    sx: {
      width: "100%",
      borderRadius: 3,
      background: "#ffffff36"
    },
    height: 150
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
    container: true,
    item: true,
    xs: 12
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
    variant: "text",
    sx: {
      fontSize: "1.6rem",
      width: "100%",
      margin: "auto",
      background: "#ffffff36"
    }
  })));
};

/***/ })

}]);